import React from "react";
import { Link } from "react-router-dom";
import { History } from "history";

import { Box, CampoEstatico, TipoCampoEstatico, Alerta, TipoAlerta, Botao, Combo } from "@intechprev/componentes-web";
// import { EmprestimoDetalhe } from "./EmprestimoDetalhe";

import { EmprestimoService } from "../../../services";
import { ContratoEntidade, SitContratoEntidade } from "../../../entidades";

import { Page } from "../../";
import { NumFuncionalidade } from "../../Page";

interface Props {
  history?: History;
}

interface State {
  emprestimos: Array<ContratoEntidade>;
  erro: string;
  situacao: string;
  situacaoSelecionada: SitContratoEntidade;
  listaSituacoes: Array<SitContratoEntidade>;
}

export class EmprestimoLista extends React.Component<Props, State> {

  private page = React.createRef<Page>();

  private ref_cor: { [index: string]: string } = {
    "1": "warning",
    "2": "warning",
    "3": "success",
    "5": "danger",
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      emprestimos: [],
      listaSituacoes: [],
      erro: "",
      situacao: "3",
      situacaoSelecionada: new SitContratoEntidade()
    };
  }

  componentDidMount = async () => {
    await this.page.current.loading(true);
    try {
      const listaSituacoes = await EmprestimoService.BuscarSituacoes();
      const situacaoSelecionada = listaSituacoes[0];
      const situacao = situacaoSelecionada.CD_SITUACAO.toString();

      this.setState({
        listaSituacoes,
        situacaoSelecionada,
        situacao
      });

      await this.buscar();
    } catch (err) {
      this.setState({
        erro: err.response ? err.response.data : err
      });
    }
    finally {
      await this.page.current.loading(false);
    }
  };

  buscar = async () => {
    await this.page.current.loading(true);
    try {
      const situacao = parseInt(this.state.situacao, 10);

      const situacaoSelecionada = this.state.listaSituacoes.filter((sit) => sit.CD_SITUACAO === situacao)[0];

      const emprestimos = await EmprestimoService.BuscarPorSituacao(situacao);

      this.setState({
        emprestimos,
        situacaoSelecionada
      });
    } catch (err) {
      this.setState({
        erro: err.response ? err.response.data : err
      });
    }
    finally {
      await this.page.current.loading(false);
    }
  };

  montarLink = (numero: any, ano: any) => {
    return `emprestimo/detalhe/${numero}/${ano}`;
  };

  render() {
    return (
      <Page Funcionalidade={NumFuncionalidade.EMPRESTIMOS_CONSULTA} {...this.props} ref={this.page}>
        <Botao className={"mb-3"} onClick={() => this.props.history.push("/emprestimo/simulador")} titulo={"Simular Empréstimo"} />

        {this.state.listaSituacoes.length > 0 &&
          <Box titulo={"Selecione uma Situação para visualizar seus empréstimo"}>
            <Combo
              contexto={this}
              nome={"situacao"}
              valor={this.state.situacao}
              opcoes={this.state.listaSituacoes}
              padrao={this.state.situacao}
              onChange={this.buscar}
              nomeMembro={"DS_SITUACAO"}
              valorMembro={"CD_SITUACAO"}
            />
          </Box>
        }

        <Box titulo={"Empréstimos Concedidos - " + this.state.situacaoSelecionada.DS_SITUACAO}>

          {this.state.emprestimos.length === 0 && <Alerta mensagem={"Você não possui nenhum empréstimo concedido com a Fundação São Francisco para essa situação."} tipo={TipoAlerta.danger} />}

          {this.state.emprestimos.length > 0 &&
            <table className={"table"}>
              <thead>
                <tr>
                  <th>Situação</th>
                  <th>Nº/Ano</th>
                  <th>Solicitação</th>
                  <th>Crédito</th>
                  <th>Valor Solicitado</th>
                  <th>Valor Prestação</th>
                  <th>Valor Líquido</th>
                  <th>Prazo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.emprestimos.map((info: any, index: number) => {
                  return (
                    <tr key={index}>
                      <td>
                        <i className={`mr-2 fas fa-circle text-${this.ref_cor[this.state.situacaoSelecionada.CD_SITUACAO.toString()]}`}></i>
                        {this.state.situacaoSelecionada.DS_SITUACAO}
                      </td>
                      <td>{`${info.NUM_CONTRATO}/${info.ANO_CONTRATO}`}</td>
                      <td>{info.DT_SOLICITACAO}</td>
                      <td>{info.DT_CREDITO}</td>
                      <td>
                        <CampoEstatico valor={info.VL_SOLICITADO} tipo={TipoCampoEstatico.dinheiro} />
                      </td>
                      <td>
                        <CampoEstatico valor={info.VL_PRESTACAO} tipo={TipoCampoEstatico.dinheiro} />
                      </td>
                      <td>
                        <CampoEstatico valor={info.VL_LIQUIDO} tipo={TipoCampoEstatico.dinheiro} />
                      </td>
                      <td>{info.PRAZO}</td>
                      <td>
                        <Link className={"text-primary"} to={this.montarLink(info.NUM_CONTRATO, info.ANO_CONTRATO)}>
                          Detalhar
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          }

          {this.state.emprestimos.filter((x) => x.CD_SITUACAO === 0).length > 0 && (
            <Alerta
              tipo={TipoAlerta.info}
              mensagem={
                "Para cancelar o empréstimo com situação em <b>SIMULAÇÃO</b>, é necessário solicitar por e-mail, colocando no assunto Cancelamento do Empréstimo e o número da sua matrícula, até o dia 20 do mês do crédito do empréstimo."
              }
            />
          )}
        </Box>
      </Page>
    );
  }
}
